<template>
  <MobileContainer flex-content>
    <MobileHeader slot="header"
                  nav-action="menu"
                  show-cart>
      {{ currentProduct.name }}
    </MobileHeader>

    <Configurator />

    <!-- Modals -->
    <MobileModal v-model="isShowHelpModal"
                 animation="modal"
                 center-content
                 close-on-overlay >
      <HelpModal :class="$style.helpModal" />
    </MobileModal>

    <MobileModal v-model="showConfirmLeave"
                 dialog
                 center-content>
      <MobileConfirmDialog title="Abandon Boss Creation?"
                           cancel-text="No"
                           confirm-text="Yes, Abandon"
                           @confirm="confirmLeave()"
                           @cancel="cancelLeave()">
        Are you sure you want to abandon this creation?
      </MobileConfirmDialog>
    </MobileModal>
    <!-- / Modals -->

  </MobileContainer>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileContainer from '@/apps/mobile/components/MobileContainer';
import MobileHeader from '@/apps/mobile/components/MobileHeader';
import Configurator from '@/apps/configurator/components/Configurator';
import MobileModal from '@/apps/mobile/components/MobileModal';
import MobileConfirmDialog from '@/apps/mobile/components/MobileConfirmDialog';
import HelpModal from '@/components/HelpModal';
import { Getter, Action } from 'vuex-class';
import { HIDE_HELP } from '@/apps/configurator/store/types';

/**
 * Mobile configurator.
 */
@Component({
  components: {
    MobileHeader,
    MobileContainer,
    Configurator,
    MobileModal,
    HelpModal,
    MobileConfirmDialog,
  },
})
export default class MobileConfigurator extends Vue {
  @Getter('configuratorHelpShow') showHelpModal;
  @Getter orderItemCompleted;
  @Getter orderItemId;
  @Getter cartLength;
  @Getter productByKey;
  @Getter currentProductKey;
  @Action(HIDE_HELP) hideHelp;

  /**
   * Show confirm leave modal.
   * @type {Boolean}
   */
  showConfirmLeave = false;

  /**
   * Next route.
   * @type {function}
   */
  nextRoute = null;

  /**
   * Current product.
   */
  get currentProduct() {
    return this.productByKey(this.currentProductKey);
  }

  /**
   * Is show help modal getter.
   */
  get isShowHelpModal() {
    return this.showHelpModal;
  }

  /**
   * Is show help modal setter.
   */
  set isShowHelpModal(value) {
    if (!value) {
      this.hideHelp();
    }
  }

  /**
   * Confirm leave page action.
   */
  confirmLeave() {
    this.nextRoute();
  }

  /**
   * Cancel leave page action.
   */
  cancelLeave() {
    this.showConfirmLeave = false;
  }

  beforeRouteLeave(to, from, next) {
    if (!this.orderItemCompleted && this.cartLength > 0) {
      this.showConfirmLeave = true;
      this.nextRoute = next;
      next(false);

      return;
    }
    next();
  }
}
</script>

<style lang="scss" module>
.helpModal {
  margin: auto;
  max-width: 317px;
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileConfigurator.vue